import { PostTypeReel } from '~publish/legacy/post/constants'

import type { Service, TakeawayCreatePostType } from '../../graphqlEnums'

type PrefillPostData = {
  updateType?: string
}

export type CreatePostPrefillResult = {
  prefillPostData?: PrefillPostData
  activeSidePanel?: 'templates' | 'aiAssistant'
  prefillAiPrompt?: string
}

/** Maps a Takeaway's recommended post format + channel service to composer prefill options. */
export function getCreatePostPrefill(
  createPostType?: TakeawayCreatePostType | null,
  channelService?: Service | null,
  prefillAiPrompt?: string | null,
): CreatePostPrefillResult {
  if (createPostType === 'reel' && channelService === 'instagram') {
    return { prefillPostData: { updateType: PostTypeReel } }
  }

  if (createPostType === 'template') {
    return { activeSidePanel: 'templates' }
  }

  if (createPostType === 'startWithAi') {
    return {
      activeSidePanel: 'aiAssistant',
      ...(prefillAiPrompt && { prefillAiPrompt }),
    }
  }

  return {}
}
